var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoRecordings = function SvgIcoRecordings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m.096-14H7v8h1.763v-3.198h.87L11.305 14h2.113l-2.034-3.379q.848-.158 1.288-.745.441-.6.441-1.447 0-.7-.249-1.163a1.86 1.86 0 0 0-.655-.746 2.6 2.6 0 0 0-.96-.396A5 5 0 0 0 10.096 6m-.294 3.31h-1.04V7.493h1.153q.237 0 .486.033.25.034.44.136.193.09.317.271.125.18.125.486 0 .328-.147.509a.83.83 0 0 1-.35.27 1.9 1.9 0 0 1-.487.102q-.26.012-.497.012",
    clipRule: "evenodd"
  })));
};
export default SvgIcoRecordings;